import { apiSlice } from "@/shared/api/api-slice"
import type { UsageStats } from "@/shared/types/api/business-mode.types"

export const getUsageStatsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessUsageStats"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getUsageStats: builder.query<UsageStats, undefined>({
        query: () => `/api/v1/business/subscriptions/usage`,
        providesTags: () => [{ type: "BusinessUsageStats" as const }]
      })
    })
  })

export const { useGetUsageStatsQuery } = getUsageStatsApi
